// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CHAI1_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CHAI1,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input FASTA': {
        systemName: 'Input FASTA',
        displayName: 'Input FASTA',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Predicted structure': {
        systemName: 'Predicted structure',
        displayName: 'Predicted structure',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      },
      'Prediction metadata': {
        systemName: 'Prediction metadata',
        displayName: 'Prediction metadata',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      }
    },
    config: {
      structurePredictionRunId: {
        kind: 'integer',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
